export enum AppActionTypes {
    SetLoadingStatus = "[App] Set Loading Status",
    SetVerificationCode = "[App] Set Verification Code",
    SetContractData = "[App] Set Contract Data",
    SetSuccessFulRegistration = "[App] Set Successful Registration",
    SetIsUsedCode = "[App] Set Is used code",
    SetReferral = "[App] Set referral"
}
